"use strict";
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var commonConfig = {
    hideFlexNavigateBar: [
        'pricing'
    ],
    redirectCnIgnore: [
        '/report-platform/complainant',
        '/report-platform/confirm'
    ],
    refererNeedCnMap: [
        'console.intl.cloud.tencent.com',
        'console.intl.cloud.tencent.cn',
        'console.intl.cloud.tencent.com.cn', 
    ]
};
var DOMAINS = {
    com: 'intl.cloud.tencent.com',
    cn: 'intl.cloud.tencent.cn',
    comCn: 'intl.cloud.tencent.com.cn',
    localCom: 'dev.intl.cloud.tencent.com:3001',
    localCn: 'dev.intl.cloud.tencent.cn:3001',
    localComCn: 'dev.intl.cloud.tencent.com.cn:3001'
};
var _obj;
commonConfig.documentPdfConfig = {
    pdfConvertOn: true,
    pdfDomainConfig: (_obj = {
    }, _defineProperty(_obj, DOMAINS.cn, {
        domainPrefix: 'cn'
    }), _defineProperty(_obj, DOMAINS.comCn, {
        domainPrefix: 'com-cn'
    }), _defineProperty(_obj, DOMAINS.com, {
        domainPrefix: null
    }), _defineProperty(_obj, DOMAINS.localCn, {
        domainPrefix: 'cn'
    }), _defineProperty(_obj, DOMAINS.localComCn, {
        domainPrefix: 'com-cn'
    }), _defineProperty(_obj, DOMAINS.localCom, {
        domainPrefix: null
    }), _obj)
};
commonConfig.domainFormatConfig = {
    keepUnnecessaryDomainInUrl: true
};
module.exports = commonConfig;
